import '../../css/Colors.css'
import '../../css/Text.css'
import '../../css/BaseElements/TopBar/LogoutComponent.css'
import 'bootstrap-icons/font/bootstrap-icons.css';

function LogoutComponent({text, onLogout}) {
    return (
        <div className='logoutComponent'>
            <div className='therapistName'> {text} </div>
            <button onClick={onLogout}>Logout</button>
        </div>
    
    );
}

export default LogoutComponent;
